import { createStaffDiagnosticsApi, createStaffProviderHealthApi } from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import type { DiagnosticsRuntime } from "./runtime";

/** The runtime of the real admin app: the typed clients over `fetch` and the clock. The bearer token comes from the shared function. */
export function createAdminDiagnosticsRuntime(): DiagnosticsRuntime {
  const config = getAdminPublicConfig();
  const options = { baseUrl: config.apiUrl.toString(), getAccessToken: currentAccessToken };
  return {
    health: createStaffProviderHealthApi(options),
    api: createStaffDiagnosticsApi(options),
    now: () => new Date(),
  };
}
